/** 短縮URL生成API Mockレスポンス */
const ShortUrl = (num: string) => {
  return {
    shortUrl: `https://eqm.page.link/${num}`,
  };
};

export default ShortUrl;
